"use client";
import React from "react";
import Link from "components/common/Link";
import { BookingQRModal } from "components/common";
import OfferDetailModal from "components/home/OfferDetailModal";
import OfferCard from "components/home/Card/OfferCard";
import { get } from "utils/lodash";
import { useT } from "providers/I18nProvider";

/**
 * "Ưu đãi tại <shop>": dải ưu đãi (campaignPackage type=service) CỦA CHÍNH shop
 * đang xem. Tái dùng OfferCard + OfferDetailModal của trang chủ để card đồng bộ.
 * Data lấy ở server (page.tsx) để Google thấy ưu đãi + không trống lúc tải.
 * Không có ưu đãi => trả null (không để khối rỗng giữa trang).
 */
const ShopOffers: React.FC<{ items?: any[] }> = ({ items = [] }) => {
  const t = useT();
  const [selected, setSelected] = React.useState<any>(null);
  const [qrOpen, setQrOpen] = React.useState(false);

  if (!items.length) return null;

  return (
    <>
      <section className="md:rounded-2xl md:bg-gradient-to-b md:from-[#eefbfb] md:via-[#f7fdfd] md:to-white">
        <div className="py-4 md:p-5">
          <div className="flex items-end justify-between gap-4 mb-3 md:mb-5">
            <div>
              <h2 className="text-[17px] md:text-2xl font-extrabold text-black01 !mb-0 md:!mb-1">
                {t("shopOffers.title")}
              </h2>
              <p className="hidden md:block text-sm text-gray-600 !mb-0">
                {t("shopOffers.desc", { count: items.length })}
              </p>
            </div>
            <Link
              href="/uu-dai"
              className="tap-area inline-flex min-h-6 shrink-0 items-center whitespace-nowrap text-sm font-bold text-primary hover:underline"
            >
              {t("home.viewAll")} →
            </Link>
          </div>

          {/* Mobile: dải cuộn ngang thẻ 150px (đồng bộ trang chủ) · desktop: lưới 2 cột */}
          <div className="md:hidden -mx-4 px-4 flex gap-3 overflow-x-auto snap-x scrollbar-hide pt-2 -mt-2">
            {items.map((pkg, idx) => (
              <OfferCard
                key={get(pkg, "id") || idx}
                pkg={pkg}
                layout="rail"
                onClick={setSelected}
              />
            ))}
          </div>
          <div className="hidden md:grid grid-cols-2 gap-3 sm:gap-4">
            {items.map((pkg, idx) => (
              <OfferCard
                key={get(pkg, "id") || idx}
                pkg={pkg}
                layout="grid"
                onClick={setSelected}
              />
            ))}
          </div>
        </div>
      </section>

      <OfferDetailModal
        open={!!selected}
        pkg={selected}
        onClose={() => setSelected(null)}
        onBook={() => {
          setSelected(null);
          setQrOpen(true);
        }}
      />
      <BookingQRModal open={qrOpen} onClose={() => setQrOpen(false)} />
    </>
  );
};

export default ShopOffers;
